'use client';
import { Variants } from 'motion/react';
import { useMemo, useRef } from 'react';

type UseRevealNodeOptions = {
  delay?: number;
  duration?: number;
  yOffset?: number;
  ease?: [number, number, number, number];
  startDelay?: number;
};

export const useRevealNodeAnimation = ({
  delay = 0,
  duration = 0.5,
  ease = [0.625, 0.05, 0, 1] as [number, number, number, number],
  startDelay = 0,
  yOffset = 20,
}: UseRevealNodeOptions = {}) => {
  const ref = useRef<HTMLElement | null>(null);

  const variants: Variants = useMemo(
    () => ({
      hidden: { opacity: 0, y: yOffset },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          delay: startDelay + delay,
          duration,
          ease,
        },
      },
    }),
    [delay, duration, ease, startDelay, yOffset]
  );

  return { ref, variants };
};
